import appComponentsMap from "./appComponentsMap";

import ButtonItem from "./Components/ButtonItem";
import Buttons from "./Components/Buttons";
import Column from "./Components/Column";
import ColumnGroup from "./Components/ColumnGroup";
import Divider from "./Components/Divider";
import Heading from "./Components/Heading";
import Html from "./Components/Html";
import Row from "./Components/Row";
import Style from "./Components/Style";
import Text from "./Components/Text";
import Image from "./Components/Image";
import { Slider, Slide } from "./Components/Slider";
import Map from "./Components/Map";

const defaultComponentsMap = {
  "button-item": ButtonItem,
  buttons: Buttons,
  column: Column,
  "column-group": ColumnGroup,
  divider: Divider,
  heading: Heading,
  html: Html,
  row: Row,
  slider: Slider,
  slide: Slide,
  style: Style,
  text: Text,
  map: Map,
  image: Image,
};

const componentsMap = {
  ...defaultComponentsMap,
  ...appComponentsMap,
};

export { componentsMap };
